import { cn } from '@/lib/utils/cn';
import { T_VariantType } from '@/ts/types/T_VariantType';

export const tabTriggerBaseStyles = cn(
  'flex-1 bg-transparent data-[state=inactive]:bg-background',
  'border border-base-border/20 px-3 py-2',
  'flex items-center justify-center gap-1.5',
  'data-[state=active]:bg-accent data-[state=active]:text-foreground',
  'data-[state=active]:font-bold data-[state=active]:leading-normal'
);

export const modalVariants: Record<
  T_VariantType,
  { bgGradient: string; bgImage: string }
> = {
  BTC: {
    bgGradient: 'bg-[image:var(--custom-amber-radial-gradient)]',
    bgImage: "bg-[url('/assets/icons/coin/BTC.svg')]"
  },
  ETH: {
    bgGradient: 'bg-[image:var(--custom-blue-radial-gradient)]',
    bgImage: "bg-[url('/assets/icons/coin/ETH.svg')]"
  },
  SOL: {
    bgGradient: 'bg-[image:var(--custom-purple-radial-gradient)]',
    bgImage: "bg-[url('/assets/icons/coin/SOL.svg')]"
  },
  XRP: {
    bgGradient: 'bg-[image:var(--custom-sky-radial-gradient)]',
    bgImage: "bg-[url('/assets/icons/coin/XRP.svg')]"
  }
};
